import React, { useEffect, useState } from "react";
import { useInternet } from "../../../../../../../hooks/useInternet.js";
import { SelectInput } from "../../../../../../../components/inputs/selectInput.jsx";
import countries from "i18n-iso-countries";
import i18n_iso_countries from "i18n-iso-countries/langs/en.json";
import { TextInput } from "../../../../../../../components/inputs/textInput.jsx";
import { useNavigate } from "react-router-dom";
import { HOST } from "../../../../../../../hooks/constants.js";
import { useSelector } from "react-redux";

countries.registerLocale(i18n_iso_countries);

export function StepAccountAdd({ bank, setBank }) {
  let session = useSelector((state) => state.session);
  let [banks, setBanks] = useState([]);
  let [country, setCountry] = useState(session?.account?.companyCountry);
  let [search, setSearch] = useState("");
  let internet = useInternet();
  let navigate = useNavigate();
  let changeCountry = (country) => {
    setCountry(country);
    setBanks([]);
    internet
      .get("/bank_accounts/list_banks?country=" + country)
      .then(async (res) => {
        setBanks(await res.json());
      });
  };
  useEffect(() => {
    changeCountry(country);
  }, []);
  let filteredBanks = banks.filter(({ name }) =>
    name.toLowerCase().includes(search.toLowerCase())
  );
  let selectBank = (id) => {
    window.location.href =
      HOST +
      "/bank_accounts/connect/" +
      id +
      "?token=" +
      window.localStorage.token;
  };

  return (
    <div className={"flex flex-col gap-3"} style={{ height: 400 }}>
      <h1 className={"font-bold"}>Add your account</h1>
      <SelectInput
        value={country}
        onChange={changeCountry}
        select={{
          options: Object.entries(countries.getNames("en")).map(
            ([value, label]) => {
              return {
                value,
                label,
              };
            }
          ),
        }}
      />
      <TextInput value={search} onChange={setSearch} placeholder={"Search"} />
      <div className={"grid grid-cols-2 gap-3 flex-grow overflow-auto"}>
        {country ? (
          <>
            {!banks.length && (
              <div>
                <span className={"fa fa-spinner fa-spin"} />
              </div>
            )}
            {filteredBanks.map(({ id, name, logo }) => (
              <div
                className={
                  "bg-blue-50 hover:bg-blue-100 cursor-pointer p-5 rounded flex flex-col gap-3 text-center items-center justify-center"
                }
                style={{ height: 150 }}
                onClick={() => selectBank(id)}
              >
                <div className={"font-medium"}> {name}</div>
                <div className={"flex-grow overflow-hidden"}>
                  <img
                    src={logo}
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                  />
                </div>
              </div>
            ))}
          </>
        ) : (
          <div>Please select a country</div>
        )}
      </div>
    </div>
  );
}
